import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Layout from '@/views/layouts/desktop/Root.vue';
import Menus from './Menus.vue';
import Top from './Top.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, { "left-width": 220 }, {
    "left-side": _withCtx(() => [
      _createVNode(Menus)
    ]),
    "top-bar": _withCtx(() => [
      _createVNode(Top)
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})